/* Beaux-Arts — lightbox
   Any [data-ba-zoom] button opens its image full screen. Buttons sharing a
   data-gallery value navigate as one set. Near-white scrim, arrows left and
   right, arrow keys and swipe, Escape or backdrop click to close. */

(function () {
  var overlay, imgEl, capEl, prevBtn, nextBtn, closeBtn;
  var items = [];
  var index = 0;
  var lastFocused = null;

  function build() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'ba-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;

    overlay.innerHTML = [
      '<button type="button" class="ba-lightbox__close" aria-label="Close">',
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1 1l18 18M19 1L1 19" stroke="currentColor" stroke-width="1.2"/></svg>',
      '</button>',
      '<button type="button" class="ba-lightbox__nav ba-lightbox__nav--prev" aria-label="Previous">',
      '<svg viewBox="0 0 12 20" aria-hidden="true"><path d="M11 1L2 10l9 9" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>',
      '</button>',
      '<button type="button" class="ba-lightbox__nav ba-lightbox__nav--next" aria-label="Next">',
      '<svg viewBox="0 0 12 20" aria-hidden="true"><path d="M1 1l9 9-9 9" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>',
      '</button>',
      '<figure class="ba-lightbox__stage">',
      '<img class="ba-lightbox__img" alt="">',
      '<figcaption class="ba-lightbox__caption"></figcaption>',
      '</figure>'
    ].join('');

    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.ba-lightbox__img');
    capEl = overlay.querySelector('.ba-lightbox__caption');
    prevBtn = overlay.querySelector('.ba-lightbox__nav--prev');
    nextBtn = overlay.querySelector('.ba-lightbox__nav--next');
    closeBtn = overlay.querySelector('.ba-lightbox__close');

    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    closeBtn.addEventListener('click', close);

    // Clicking the scrim closes; clicking the picture itself does not.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('ba-lightbox__stage')) close();
    });

    var startX = null;
    overlay.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });
  }

  function render() {
    var el = items[index];
    if (!el) return;

    imgEl.src = el.dataset.full;
    imgEl.alt = el.dataset.caption || '';

    var caption = el.dataset.caption || '';
    capEl.textContent = caption;
    capEl.style.display = caption ? '' : 'none';

    var many = items.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
  }

  function step(delta) {
    if (!items.length) return;
    index = (index + delta + items.length) % items.length;
    render();
  }

  function open(button) {
    build();

    var group = button.dataset.gallery;
    items = group
      ? Array.prototype.slice.call(document.querySelectorAll('[data-ba-zoom][data-gallery="' + group + '"]'))
      : [button];
    index = Math.max(0, items.indexOf(button));

    lastFocused = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    render();
    closeBtn.focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    imgEl.src = '';
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('[data-ba-zoom]') : null;
    if (!button) return;
    e.preventDefault();
    open(button);
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay || overlay.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });
})();
